import { useEffect, useRef } from "react";
import { XMarkIcon } from "@heroicons/react/24/solid";
export default function Modal({ component: Component, isOpen, onClose }) {
    const modalRef = useRef();
  
    useEffect(() => {
      const handleClickOutside = (e) => {
        if (modalRef.current && !modalRef.current.contains(e.target)) {
          onClose();
        }
      };
  
      const handleEscape = (e) => {
        if (e.key === "Escape") {
          onClose();
        }
      };
  
      if (isOpen) {
        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("keydown", handleEscape);
      }
  
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
        document.removeEventListener("keydown", handleEscape);
      };
    }, [isOpen, onClose]);
  
    if (!isOpen) return null;
  
    return (
      <div className="fixed inset-0 bg-black/40 z-40 px-4 pt-20 pb-8 overflow-y-auto">
        <div ref={modalRef} className="bg-white p-4 rounded-2xl shadow-lg w-full max-w-md mx-auto relative space-y-4">
          <div className="flex items-center justify-end">
            <button onClick={onClose} className="text-gray-400 hover:text-black" title="Close">
              <XMarkIcon className="h-5 w-5" />
            </button>
          </div>
          <div className="space-y-2 max-h-[75vh] overflow-y-auto">
            <Component />
          </div>
        </div>
      </div>
    );
  }
  